<template>
  <div class="filter_bar_container">
    <div :class="'filter_dropdown' + (showFilterDown || origin === 'webpage' ? ' show' : '')">
      <div v-if="origin !== 'webpage'" class="filter_dropdown_main" @click="toggleFilterDropdown()">
        <span>All</span>
        <img class="lazyload" :data-src="contentCloudFront('/assets/v4/community/com-arrow.png')">
      </div>
      <div class="filter_dropdown_items">
        <div :class="'filter_dropdown_item' + (expandEvent ? ' active' : '')" @click="toggleFilterEvent()">
          <img v-if="!expandEvent" class="lazyload" :data-src="contentCloudFront('/assets/search_bar/expand_filter.png')" width="15" height="15">
          <img v-else :src="contentCloudFront('/assets/search_bar/collapse_filter.png')" width="15" height="15">
          <span>Event</span>
        </div>
        <div v-show="expandEvent">
          <div class="filter_dropdown_item child">
            <label class="filter_check_label">
              <input v-model="featured" type="checkbox" @change="filterEvent()">
              <div class="filter_checkbox" />
              <span>Featured</span>
            </label>
          </div>
          <div class="filter_dropdown_item child" @click="toggleFilterEventPlatform()">
            <img v-if="!expandPlatform" class="lazyload" :data-src="contentCloudFront('/assets/search_bar/expand_filter.png')" width="15" height="15">
            <img v-else :src="contentCloudFront('/assets/search_bar/collapse_filter.png')" width="15" height="15">
            <span>Platform</span>
          </div>
          <div v-show="expandPlatform">
            <div class="filter_dropdown_item child child_2x">
              <label class="filter_check_label">
                <input v-model="platform.pc" type="checkbox" @change="filterEvent()">
                <div class="filter_checkbox" />
                <span>PC</span>
              </label>
            </div>
            <div class="filter_dropdown_item child child_2x">
              <label class="filter_check_label">
                <input v-model="platform.xbox" type="checkbox" @change="filterEvent()">
                <div class="filter_checkbox" />
                <span>Xbox</span>
              </label>
            </div>
            <div class="filter_dropdown_item child child_2x">
              <label class="filter_check_label">
                <input v-model="platform.ps4" type="checkbox" @change="filterEvent()">
                <div class="filter_checkbox" />
                <span>Playstation</span>
              </label>
            </div>
            <div class="filter_dropdown_item child child_2x">
              <label class="filter_check_label">
                <input v-model="platform.mobile" type="checkbox" @change="filterEvent()">
                <div class="filter_checkbox" />
                <span>Switch</span>
              </label>
            </div>
          </div>
          <div class="filter_dropdown_item child" @click="toggleFilterEventType()">
            <img v-if="!expandTournamentType" class="lazyload" :data-src="contentCloudFront('/assets/search_bar/expand_filter.png')" width="15" height="15">
            <img v-else :src="contentCloudFront('/assets/search_bar/collapse_filter.png')" width="15" height="15">
            <span>Tournament Type</span>
          </div>
          <div v-show="expandTournamentType">
            <div class="filter_dropdown_item child child_2x">
              <label class="filter_check_label">
                <input v-model="tournamentType.solos" type="checkbox" @change="filterEvent()">
                <div class="filter_checkbox" />
                <span>Solos/1v1</span>
              </label>
            </div>
            <div class="filter_dropdown_item child child_2x">
              <label class="filter_check_label">
                <input v-model="tournamentType.duos" type="checkbox" @change="filterEvent()">
                <div class="filter_checkbox" />
                <span>Duos/2v2</span>
              </label>
            </div>
            <div class="filter_dropdown_item child child_2x">
              <label class="filter_check_label">
                <input v-model="tournamentType.trios" type="checkbox" @change="filterEvent()">
                <div class="filter_checkbox" />
                <span>Trios/3v3</span>
              </label>
            </div>
            <div class="filter_dropdown_item child child_2x">
              <label class="filter_check_label">
                <input v-model="tournamentType.squads" type="checkbox" @change="filterEvent()">
                <div class="filter_checkbox" />
                <span>Quads/4v4</span>
              </label>
            </div>
            <div class="filter_dropdown_item child child_2x">
              <label class="filter_check_label">
                <input v-model="tournamentType.others" type="checkbox" @change="filterEvent()">
                <div class="filter_checkbox" />
                <span>5v5 and up</span>
              </label>
            </div>
          </div>
        </div>
        <div :class="'filter_dropdown_item' + (expandHub ? ' active' : '')" @click="toggleFilterHub()">
          <img v-if="!expandHub" class="lazyload" :data-src="contentCloudFront('/assets/search_bar/expand_filter.png')" width="15" height="15">
          <img v-else :src="contentCloudFront('/assets/search_bar/collapse_filter.png')" width="15" height="15">
          <span>Hub</span>
        </div>
        <div v-show="expandHub">
          <div class="filter_dropdown_item child">
            <label class="filter_check_label">
              <input v-model="hubType.all" type="checkbox" @change="filterHub(1)">
              <div class="filter_checkbox" />
              <span>All Hubs</span>
            </label>
          </div>
          <div class="filter_dropdown_item child">
            <label class="filter_check_label">
              <input v-model="hubType.highschool" type="checkbox" @change="filterHub()">
              <div class="filter_checkbox" />
              <span>High School</span>
            </label>
          </div>
          <div class="filter_dropdown_item child">
            <label class="filter_check_label">
              <input v-model="hubType.college" type="checkbox" @change="filterHub()">
              <div class="filter_checkbox" />
              <span>College</span>
            </label>
          </div>
          <!--<div class="filter_dropdown_item child">
            <label class="filter_check_label">
              <input v-model="hubType.gaming" type="checkbox" @change="filterHub()">
              <div class="filter_checkbox" />
              <span>Game Hub</span>
            </label>
          </div>-->
        </div>
        <!--
        <div class="filter_dropdown_item">
          <img class="lazyload" :data-src="contentCloudFront('/assets/search_bar/expand_filter.png')" width="15" height="15" />
          <span>Users</span>
        </div>
        -->
        <div class="filter_dropdown_item">
          <label class="filter_check_label">
            <input v-model="newsFilter" type="checkbox" @change="filterNews()">
            <div class="filter_checkbox" />
            <span>News</span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { component } from '../../mixins/component';

export default {
  components: {},
  mixins: [component],
  props: {
    origin: {
      type: String,
      default() {
        return '';
      },
    },
    onFilter: {
      type: Function,
      default: () => {},
    },
    filterData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      showFilterDown: false,
      expandEvent: false,
      expandPlatform: false,
      expandTournamentType: false,
      expandHub: false,
      featured: true,
      expandNews: false,
      tournamentType: {
        solos: false,
        duos: false,
        trios: false,
        squads: false,
        others: false,
      },
      platform: {
        pc: false,
        xbox: false,
        ps4: false,
        mobile: false,
      },
      hubType: {
        all: true,
        highschool: true,
        college: true,
        // gaming: true,
      },
      newsFilter: true,
    };
  },
  computed: {

  },
  watch: {
    filterData: {
      handler(newVal, oldVal){
        this.initData();
      },
      deep: true,
    },
  },
  created() {
    if (Object.keys(this.filterData).length > 0) {
      this.initData();
    }
  },
  methods: {
    initData() {
      var self = this;
      Object.keys(this.filterData).forEach(key => {
        if (key === 'featured') {
          this.featured = parseInt(this.filterData[key]) === 1;
        } else if (key === 'news_filter') {
          this.newsFilter = parseInt(this.filterData[key]) === 1;
        } else if (key === 'tournament_type') {
          Object.keys(this.tournamentType).forEach(function(type) {
            self.tournamentType[type] = false;
          });
          for (var k = 0; k < this.filterData[key].length; k++) {
            this.tournamentType[this.filterData[key][k]] = true;
          }
        } else if (key === 'platform') {
          Object.keys(this.platform).forEach(function(type) {
            self.platform[type] = false;
          });
          for (var j = 0; j < this.filterData[key].length; j++) {
            this.platform[this.filterData[key][j]] = true;
          }
        } else if (key === 'hub_type') {
          Object.keys(this.hubType).forEach(function(type) {
            self.hubType[type] = false;
          });
          for (var i = 0; i < this.filterData[key].length; i++) {
            this.hubType[this.filterData[key][i]] = true;
          }
        }
      });
    },
    toggleFilterDropdown() {
      this.showFilterDown = !this.showFilterDown;
    },
    toggleFilterHub() {
      this.expandHub = !this.expandHub;
    },
    toggleFilterEvent() {
      this.expandEvent = !this.expandEvent;
    },
    toggleFilterEventPlatform() {
      this.expandPlatform = !this.expandPlatform;
    },
    toggleFilterEventType() {
      this.expandTournamentType = !this.expandTournamentType;
    },
    toggleFilterNew() {
      this.expandNews = !this.expandNews;
    },
    filterEvent() {
      var eventFilterData = {
        'featured': this.featured,
        'tournament_type': this.tournamentType,
        'platform': this.platform,
      };
      this.onFilter('event', eventFilterData);
    },
    filterHub(allChange = 0) {
      var self = this;
      if (allChange) {
        Object.keys(this.hubType).forEach(function(type) {
          self.hubType[type] = self.hubType['all'];
        });
      } else {
        var countHubType = 0;
        Object.keys(this.hubType).forEach(function(type) {
          if (type !== 'all' && self.hubType[type]) {
            countHubType++;
          }
        });
        if (countHubType === Object.keys(this.hubType).length - 1) {
          self.hubType['all'] = true;
        } else {
          self.hubType['all'] = false;
        }
      }
      this.onFilter('hub', this.hubType);
    },
    filterNews() {
      this.onFilter('news', this.newsFilter);
    },
  },
};
</script>

